import type { ToggleSwitchDesignTokens, ToggleSwitchTokenSections } from '@openng/optimus-ui-themes/types/toggleswitch';

export const handle: ToggleSwitchTokenSections.Handle = {
	borderRadius: '{toggleswitch.handle.size} / 2',
};

export default {
	handle,
} satisfies ToggleSwitchDesignTokens;
